import React, { useState } from "react";
import { Settings, Mail, Globe, Linkedin, Layers, MessageSquareShare, Expand } from "lucide-react";
import DomainExpandQueue from "../components/QueueManagement/DomainExpandQueue";
import LinkedInConnectQueue from "../components/QueueManagement/LinkedInConnectQueue";
import EmailQueue from "../components/QueueManagement/EmailQueue";
import ExpandiScrapingQueue from "../components/QueueManagement/ExpandiScrapingQueue";
import ColdOutreachQueue from "../components/QueueManagement/OutreachQueue";
import LeverageEnhancementQueue from "../components/QueueManagement/LeverageEnhancementQueue";

const PRIMARY_TABS = [
    { key: "domain", label: "Domain Expand", icon: Expand },
    { key: "scraping", label: "LinkedIn Scraping", icon: Linkedin },
    { key: "leverage", label: "Leverage Enhancement", icon: Globe },
];

const OUTREACH_TABS = [
    { key: "outreach", label: "Cold Outreach", icon: MessageSquareShare },
    { key: "email", label: "Cold Email", icon: Mail },
];

export default function QueueManagementPage() {
    const [active, setActive] = useState("domain");

    const cardClass = "rounded-2xl border border-slate-200 bg-white shadow-sm";
    const tabBase =
        "group inline-flex h-11 items-center gap-2 rounded-2xl border px-4 text-sm font-semibold shadow-sm transition focus:outline-none focus:ring-2 focus:ring-slate-900/20";
    const tabActive = "border-slate-900 bg-slate-900 text-white";
    const tabIdle = "border-slate-200 bg-white text-slate-800 hover:bg-slate-50";

    const btnPrimary =
        "inline-flex h-11 items-center justify-center gap-2 rounded-2xl bg-slate-900 px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-900/30";

    return (
        <div className="min-h-screen bg-slate-50 p-4">
            <div className="mx-auto max-w-full space-y-6">
                {/* Header */}
                <div className={`${cardClass} px-6 py-5`}>
                    <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                        <div className="min-w-0">
                            <div className="flex items-center gap-3">
                                <div className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-900 text-white shadow-sm">
                                    <Layers className="h-5 w-5" />
                                </div>
                                <div className="min-w-0">
                                    <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">
                                        Queue Management
                                    </h1>
                                    <p className="mt-1 text-sm text-slate-600">
                                        Switch between queues and manage processing status.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => (window.location.href = "/queue-setting")}
                            className={btnPrimary}
                        >
                            <Settings className="h-4 w-4" />
                            Queue settings
                        </button>
                    </div>

                    {/* Tabs */}
                    <div className="mt-5 flex flex-wrap items-center gap-3">
                        {PRIMARY_TABS.map((t) => {
                            const Icon = t.icon;
                            const isActive = active === t.key;

                            return (
                                <button
                                    key={t.key}
                                    onClick={() => setActive(t.key)}
                                    className={`${tabBase} ${isActive ? tabActive : tabIdle}`}
                                    aria-current={isActive ? "page" : undefined}
                                >
                                    <Icon className={`h-4 w-4 ${isActive ? "text-white" : "text-slate-600"}`} />
                                    {t.label}
                                </button>
                            );
                        })}

                        {/* Outreach group */}
                        <div className="flex items-center gap-1 rounded-full border border-slate-200 bg-white shadow-sm">
                            {OUTREACH_TABS.map((t) => {
                                const Icon = t.icon;
                                const isActive = active === t.key;

                                return (
                                    <button
                                        key={t.key}
                                        onClick={() => setActive(t.key)}
                                        className={[
                                            "inline-flex h-11 items-center gap-2 rounded-full px-4 text-sm font-medium transition-all",
                                            isActive
                                                ? "bg-slate-900 text-white shadow-sm"
                                                : "bg-transparent text-slate-700 hover:bg-slate-100",
                                        ].join(" ")}
                                        aria-current={isActive ? "page" : undefined}
                                    >
                                        <Icon className={`h-4 w-4 ${isActive ? "text-white" : "text-slate-600"}`} />
                                        {t.label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="space-y-4">
                    {active === "email" && <EmailQueue />}
                    {active === "domain" && <DomainExpandQueue />}
                    {/* {active === "connect" && <LinkedInConnectQueue />} */}
                    {active === "scraping" && <ExpandiScrapingQueue />}
                    {active === "outreach" && <ColdOutreachQueue />}
                    {active === "leverage" && <LeverageEnhancementQueue />}
                </div>
            </div>
        </div>
    );
}
